import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import LeftMenu from './LeftMenu';

export default function FullLayout() {
  return (
    <>
      <Header/>
      <LeftMenu/>
      <Outlet />
      <Footer/>
    </>
  )
}
